import { removeObjEmptyVal } from 'share/util/helper'
import { service } from '.'
import { errorHandler } from 'share/util/common'

export interface Salesman {
  id: number
  name: string
  nationId: string
  email: string
  uno: string
  status: boolean
  dealerId: number
  dealerName: string
  storeId: number
  storeName: string
  storeCode: string
  score: string
  phone: string
}
export const emptySalesman = {
  id: 0,
  name: '',
  nationId: '',
  email: '',
  uno: '',
  status: true,
  dealerId: 0,
  storeId: 0,
  dealerName: '',
  storeName: '',
  storeCode: '',
  score: '',
  phone: '',
}

class SalesStore {
  private _salesmen: Salesman[] = []
  private _salesman: Salesman = { ...emptySalesman }

  get salesmen() {
    return this._salesmen
  }
  get salesman() {
    return this._salesman
  }

  loadAll = async () => {
    const res = await service.getSaless()

    if (!res.ok) await errorHandler(res)

    this._salesmen = await res.json()
  }

  loadOne = async (id: number) => {
    if (id === 0) {
      this._salesman = { ...emptySalesman }
      return
    }

    const res = await service.getSales(id)

    if (!res.ok) await errorHandler(res)

    this._salesman = await res.json()
  }

  save = async (salesman: Salesman) => {
    const { id, name, uno, nationId, email, status, dealerId, storeId, dealerName, storeName, phone } = salesman

    const basePayload = removeObjEmptyVal({
      name,
      uno,
      nationId,
      email,
      dealerId,
      storeId,
      dealerName,
      storeName,
      phone,
    })

    const res =
      id === 0
        ? await service.addSales(basePayload)
        : await service.updateSales({
            ...basePayload,
            id,
            status,
          })

    if (!res.ok) await errorHandler(res)
  }

  getExamResult = async (dealerId: number, filename: string) => {
    const res = await service.getExamResult(dealerId)

    if (!res.ok) await errorHandler(res)

    const buffer = await res.arrayBuffer()
    const url = URL.createObjectURL(new Blob([buffer]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    link.click()
  }
}

export const salesStore = new SalesStore()
